// 公用方法

exports.install = function (Vue) {
	Vue.prototype.$_base_rem = function (){//全局函数1
        //根据比例改变 HTML字号大小
        var docEle = document.documentElement, //获取html元素
        width = docEle.clientWidth;
        width && (docEle.style.fontSize = (width>1200 ? 1200 : width) / 10 + 'px'); //设置html的fontSize，随着event的改变而改变。
	};

	Vue.prototype.$_base_isMobile = function (){//全局函数1
        //根据比例改变 HTML字号大小
        var docEle = document.documentElement, //获取html元素
            width = docEle.clientWidth;
            var bool = width > 800 ? false : true;
            return bool
	};


};